import { components } from '@/generated/internal-api/openapi-types';
import type { Entity, ID, Nullable } from './Common.model';

export type MetadataGlossaryApiId = components['schemas']['MetadataGlossaryApiId.schema'];
export type MetadataGlossaryV1 = components['schemas']['MetadataGlossaryV1.schema'];

export interface MetadataFieldForOptionsValidation {
  id: ID;
  options?: Array<string>;
}

export type MetadataFieldTypes =
  | 'text'
  | 'numeric'
  | 'date'
  | 'select'
  | 'multi_select'
  | 'lookup_select'
  | 'lookup_multi_select';

export interface MetadataField extends Entity {
  type?: string;
  header?: string;
  title: string;
  field_type: MetadataFieldTypes;
  active?: boolean;
  in_use?: boolean;
  options?: Array<string>;
  read_only: boolean;
  slug: string;
  glossary_id: ID;
  api_id?: string;
  glossary_api_id?: string;
  required: boolean;
}

export interface MetadataItem {
  active: boolean;
  field_type: MetadataFieldTypes;
  id: ID;
  in_use: boolean;
  options?: Array<string>;
  read_only: false;
  slug: string;
  header?: string;
  title: string;
  type: string;
}

export interface MetadataFieldWithValue extends MetadataField {
  value: MetadataFieldValueTypes;
}

export interface MetadataColumns {
  type?: string;
  header?: string;
  title?: string;
  field_type?: MetadataFieldTypes;
  active?: boolean;
  in_use?: boolean;
  options?: Array<string>;
  read_only?: boolean;
  slug?: string;
  glossary_id?: ID;
  api_id?: string;
  value?: MetadataFieldValueTypes;
}

export interface MetadataValueRender {
  field_type?: string;
  value: Nullable<MetadataFieldValueTypes>;
}

export type MetadataFieldValueTypes = components['schemas']['MetadataV1.schema']['value'];
export type GlossaryApiId = components['schemas']['GlossaryApiId.schema'];

export interface DisplayedGroupMetadata {
  id: ID;
  required: boolean;
  schema: MetadataField;
}

export interface MetadataPostItem {
  glossary_id: ID;
  value: MetadataFieldValueTypes;
}

export interface MetadataCageCardItem {
  id: ID;
  title: string;
  value: string | Array<string>;
}

export interface StudyGroupsMetadataSettings extends Entity {
  team_id: ID;
  metadata_glossary_id: ID;
  required: boolean;
  order: number;
}

export type ModalMeta<T extends Entity> = T & {
  meta: { data: Array<MetadataFieldWithValue> };
};

export type MetadataGlossaryType = components['schemas']['MetadataGlossaryType.schema'];

export const MetadataTypes: Record<string, MetadataGlossaryType> = {
  collection_meta: 'collection_meta',
  group_meta: 'group_meta',
  global_meta: 'global_meta',
  attachment_meta: 'attachment_meta',
  sample_meta: 'sample_meta',
  study_meta: 'study_meta',
  subject_meta: 'subject_meta',
  treatment_meta: 'treatment_meta',
  user_meta: 'user_meta',
  project_meta: 'project_meta',
  project_role_meta: 'project_role_meta',
  disease_meta: 'disease_meta',
} as const;

export type MetaDataType =
  | 'study_meta'
  | 'group_meta'
  | 'subject_meta'
  | 'collection_meta'
  | 'sample_meta'
  | 'attachment_meta'
  | 'treatment_meta'
  | 'disease_meta';
